import React from "react";
import { BrowserRouter, Outlet, Route, Routes } from "react-router";
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from "react-router"; // for sentry
import * as Sentry from "@sentry/react";

let SentryRoutes = Routes;
if (import.meta.env.VITE_DEV_ENABLE_SENTRY || process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: "https://16c801e98b7e1be4291f2d1e629ac06e@o4508770928492544.ingest.us.sentry.io/4508770932031488",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/app\.fungistics\.com\/api/],
    // Session Replay is intentionally NOT enabled. Do not add
    // Sentry.replayIntegration() without explicit content masking
    // (maskAllText: true or equivalent) reviewed against the sensitive-field
    // list in PRIVACY_DESIGN.md — replay records rendered DOM content, which
    // would capture decrypted grow data on screen regardless of any
    // database-level encryption.
  });
  SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);
}

import Dashboard from "./pages/Dashboard.jsx";
import DeviceDetail from "./pages/DeviceDetail.jsx";
import Analytics from "./pages/Analytics.jsx";
import Settings from "./pages/Settings.jsx";
import Support from "./pages/Support.jsx";
import Profile from "./pages/Profile.jsx";
import Grows from "./pages/Grows.jsx";
import GrowNew from "./pages/GrowNew.jsx";
import GrowDetail from "./pages/GrowDetail.jsx";
import Recipes from "./pages/Recipes.jsx";
import RecipeNew from "./pages/RecipeNew.jsx";
import RecipeDetail from "./pages/RecipeDetail.jsx";
import Inventory from "./pages/Inventory.jsx";
import InventoryNew from "./pages/InventoryNew.jsx";
import InventoryDetail from "./pages/InventoryDetail.jsx";
import Glossary from "./pages/Glossary.jsx";
import Authenticated from "./components/Authenticated.jsx";
import Unauthenticated from "./components/UnAuthenticated.jsx";
import Login from "./components/Login.jsx";
import Register from "./components/Register.jsx";
import ForgotPassword from "./components/ForgotPassword.jsx";
import UpdatePassword from "./components/UpdatePassword.jsx";
import InviteAccept from "./pages/InviteAccept.jsx";

import './App.css'


function App() {
  return (
    <BrowserRouter>
      <SentryRoutes>
        <Route element={<Authenticated><Outlet /></Authenticated>} >
          <Route index element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/:deviceId" element={<DeviceDetail />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/support" element={<Support />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/update-password" element={<UpdatePassword />} />
          <Route path="/grows" element={<Grows />} />
          <Route path="/grows/new" element={<GrowNew />} />
          <Route path="/grows/:growId" element={<GrowDetail />} />
          <Route path="/grows/:growId/edit" element={<Grows />} />
          <Route path="/inventory" element={<Inventory />} />
          <Route path="/inventory/new" element={<InventoryNew />} />
          <Route path="/inventory/:id" element={<InventoryDetail />} />
          <Route path="/recipes" element={<Recipes />} />
          <Route path="/recipes/new" element={<RecipeNew />} />
          <Route path="/recipes/:recipeId" element={<RecipeDetail />} />
          <Route path="/recipes/:recipeId/edit" element={<RecipeDetail />} />
          <Route path="/glossary" element={<Glossary />} />
        </Route>
        <Route element={<Unauthenticated><Outlet /></Unauthenticated>}>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
        </Route>
        <Route path="/invites/accept" element={<InviteAccept />} />
      </SentryRoutes>
    </BrowserRouter>
  )
}

export default App
